import { InnerBlocks } from '@wordpress/block-editor';

/**
 * Repeater component used in edit.js that allows for adding blocks in call out box
 **/

const CustomAppender = () => (
  <div className="custom-appender-wrapper">
    <InnerBlocks.ButtonBlockAppender />
  </div>
);

export default CustomAppender;
